<template>
    <div class="activity-config-toolbar">
        <div class="section-header-compact">
            <div class="section-actions">
                <CarbonButton variant="bulk" @click="$emit('init')">초기화</CarbonButton>
                <CarbonButton
                    variant="primary"
                    :disabled="downloadingExcel"
                    @click="$emit('excel-download')"
                >
                    Excel 다운로드
                </CarbonButton>

                <CarbonSelect
                    :value="selectedOrg == null ? '' : selectedOrg"
                    :options="orgSelectOptions"
                    placeholder="전체 조직"
                    :placeholderDisabled="false"
                    @input="$emit('update:selectedOrg', $event === '' ? null : $event)"
                />
                <CarbonSelect
                    :value="selectedFacility == null ? '' : selectedFacility"
                    :options="facilitySelectOptions"
                    placeholder="전체 시설"
                    :placeholderDisabled="false"
                    @input="$emit('update:selectedFacility', $event === '' ? null : $event)"
                />
                <CarbonSelect
                    :value="filterStatus == null ? '' : filterStatus"
                    :options="filterStatusOptions"
                    placeholder="전체 상태"
                    :placeholderDisabled="false"
                    @input="$emit('update:filterStatus', $event === '' ? null : $event)"
                />
                <CarbonButton icon-only icon="fas fa-plus" title="추가" @click="$emit('add')" />
            </div>
        </div>
    </div>
</template>

<script>
import CarbonCodes from "../../../codes";
import CarbonButton from "../../common/CarbonButton.vue";
import CarbonSelect from "../../common/CarbonSelect.vue";

export default {
    name: "ActivityConfigToolbar",
    components: { CarbonButton, CarbonSelect },
    props: {
        organizations: { type: Array, default: () => [] },
        facilities: { type: Array, default: () => [] },
        selectedOrg: { type: Number, default: null },
        selectedFacility: { type: Number, default: null },
        filterStatus: { type: String, default: null },
        downloadingExcel: { type: Boolean, default: false },
    },
    computed: {
        filterStatusOptions() {
            return CarbonCodes.draftStat.getList();
        },
        orgSelectOptions() {
            return this.organizations.map((o) => ({ value: o.orgIdx, text: o.orgName }));
        },
        facilitySelectOptions() {
            return this.facilities.map((f) => ({
                value: f.facilityIdx || f.orgFacilityIdx,
                text: f.facilityName,
            }));
        },
    },
};
</script>

<style scoped>
.section-header-compact {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 10px;
    /* padding: 8px 14px; */
    /* border-bottom: 1px solid #e2e8f0; */
    /* background: #f8fafc; */
}

.section-actions {
    display: flex;
    gap: 8px;
    align-items: center;
}

@media (max-width: 768px) {
    .section-actions {
        flex-direction: column;
        align-items: stretch;
        width: 100%;
    }

    .section-actions > * {
        width: 100%;
    }

    .section-actions {
        flex-wrap: wrap;
        gap: 8px !important;
    }
}
</style>
